import SalesPersonNavbar from "@/components/Navbars/SalesPersonNavbar";


//  Client\client-vite\src\layouts\SalesPersonLayout.tsx
import { Outlet } from "react-router-dom";
import SocketStatus from "@/components/Sockets/SocketStatus";
import { usePresence } from "@/hooks/usePresence";
import PublicFooter from "@/components/Footers/PublicFooter";
import { SidebarProvider } from "@/components/ui/sidebar";
import SalesPersonSideBar from "@/components/Sidebars/SalesPersonSideBar";

export default function SalesPersonLayout() {
    // 🔴 ensures presence is synced
    usePresence();

    return (
        <SidebarProvider>
            <div className="flex min-h-screen w-full">
                {/* Sidebar stays on the left */}
                <SalesPersonSideBar />

                {/* Main content area */}
                <div className="flex flex-1 flex-col">
                    {/* Navbar pinned to top */}
                    <header className="sticky top-0 z-50 w-full">
                        <SalesPersonNavbar />
                    </header>

                    {/* Main scrollable content */}
                    <main className="flex-1 p-6 overflow-y-auto">
                        <Outlet />
                    </main>

                    <SocketStatus />
                    <PublicFooter />
                </div>

            </div>
        </SidebarProvider>
    );
}
